import React, { useContext } from 'react'
import { AuthContext } from './authProvider'
import Button from 'react-bootstrap/Button'

const Center = ({ children }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}
  >
    {children}
  </div>
)

export function Signout() {
  const authContext = useContext(AuthContext)

  return (
    <Center>
      <Button onClick={() => authContext.logout()} variant="primary">
        Log Out
      </Button>
    </Center>
  )
}
